import axios from "axios";

export const getShowcaseList = async (
  page: number,
  size: number,
  siteNo: string,
  zoneNo: string
) => {
  try {
    const res = await axios.get(
      `${
        process.env.REACT_APP_API_URL
      }/showcase/list?page=${page}&size=${size}${
        siteNo === "all" ? "" : "&siteNo=" + siteNo
      }${zoneNo === "all" ? "" : "&zoneNo=" + zoneNo}`,
      {
        auth: {
          username: process.env.REACT_APP_API_KEY_USERNAME,
          password: process.env.REACT_APP_API_KEY_PASSWORD,
        },
      }
    );

    const result = res.data.items.map((data: any) => ({
      status: data.status,
      no: data.no,
      storeName: data.project,
      showcase: data.name,
      panelName: "-",
      id: data.id,
      temperature: data.temperature,
      battery: data.battery,
      referenceTemperature: data.referTemperature,
      lastDate: data.lastConnectedTime,
      note: data.note,
      link: data.link,
    }));

    return result;
  } catch (e) {
    return [];
  }
};

export const getEplusList = async (
  page: number,
  size: number,
  siteNo: string,
  zoneNo: string
) => {
  try {
    const res = await axios.get(
      `${process.env.REACT_APP_API_URL}/eplus/list?page=${page}&size=${size}${
        siteNo === "all" ? "" : "&siteNo=" + siteNo
      }${zoneNo === "all" ? "" : "&zoneNo=" + zoneNo}`,
      {
        auth: {
          username: process.env.REACT_APP_API_KEY_USERNAME,
          password: process.env.REACT_APP_API_KEY_PASSWORD,
        },
      }
    );

    const result = res.data.items.map((data: any) => ({
      status: data.status,
      no: data.no,
      projectName: data.project,
      panelName: data.name,
      id: data.id,
      temperature: data.temperature,
      referenceTemperature: data.referTemperature,
      note: data.note,
      link: data.link,
    }));

    return result;
  } catch (e) {
    return [];
  }
};
